import { createAction, createApiAction } from 'store';
import * as types from './ActionTypes';
import { ITemplateDataPayload } from './models';

/* SURVEY TEMPLATES	*/
export const getTemplateList = createApiAction(types.GET_TEMPLATE_LIST);
export const deleteTemplate = createApiAction(types.DELETE_TEMPLATE);
export const postTemplate = createApiAction(types.POST_TEMPLATE);
export const postMinimalTemplate = createApiAction<{
	name: string;
	isQuick: boolean;
}>(types.POST_MINIMAL_TEMPLATE);

export interface ITemplateDataAction {
	templateData?: ITemplateDataPayload;
	templateId: string;
}

export const getTemplateData = createApiAction<ITemplateDataAction>(
	types.GET_TEMPLATE_DATA,
);
export const updateTemplateData = createApiAction<ITemplateDataAction>(
	types.PATCH_TEMPLATE_DATA,
);

export const resetTemplateData = createAction(types.RESET_TEMPLATE_DATA);

export const resetMinimalTemplate = createAction(types.RESET_MINIMAL_TEMPLATE);
export const resetUpdatedTemplate = createAction(types.RESET_UPDATED_TEMPLATE);
export const resetTemplateDeleted = createAction(types.RESET_TEMPLATE_DELETED);

export const resetTemplatesError = createAction(types.RESET_TEMPLATES_ERROR);
